import { useTranslation } from 'react-i18next';
import { CardDisclosure } from '@components/card-disclosure';
import { WARNING } from '@components/card-disclosure/card-disclosure.type';
import { IconWarning } from '@components/icons/icon-warning';
import { ModalFooter } from '@components/modals/modal-footer';
import { ModalHeader } from '@components/modals/modal-header';
import { ImportCSVQrCodeIssues } from '@components/process-import-csv/process-import-csv.type';

import { createRowErrors } from '../utils/create-row-errors';

export const ConfirmImportCsv = ({
  qrWarnings,
  onContinue,
  onBack,
}: {
  qrWarnings: ImportCSVQrCodeIssues;
  onContinue: () => void;
  onBack: () => void;
}) => {
  const { emptyRows, duplicateRows, invalidRows } = qrWarnings;
  const { t } = useTranslation();
  return (
    <div className='relative'>
      <ModalHeader
        title={
          <span className='flex items-center gap-2'>
            <IconWarning className='w-5 h-5 text-orange-400 shrink-0' />
            {t('common:confirmImportCsvTitle')}
          </span>
        }
        subtitle={t('eventReport:importCsvModalSubtitle')}
      />
      <div className='px-4 py-6 sm:px-20 sm:pb-12'>
        <p className='text-sm text-secondary'>{t('common:confirmImportCsvDescription')}</p>
      </div>
      <div className='flex flex-col gap-3 px-4 mb-6 sm:px-20'>
        {emptyRows.length > 0 && (
          <CardDisclosure
            titleText={t('common:emptyRows')}
            descriptionText={`${t('common:rows')}: ${createRowErrors(emptyRows)}`}
            showChevronIcon
            variant={WARNING}
            isDefaultOpen
          />
        )}
        {duplicateRows.length > 0 && (
          <CardDisclosure
            titleText={t('common:duplicatedRows')}
            descriptionText={`${t('common:rows')}: ${createRowErrors(duplicateRows)}`}
            showChevronIcon
            variant={WARNING}
            isDefaultOpen
          />
        )}
        {invalidRows.length > 0 && (
          <CardDisclosure
            titleText={t('common:invalidQrCodeRows')}
            descriptionText={`${t('common:rows')}: ${createRowErrors(invalidRows)}`}
            showChevronIcon
            variant={WARNING}
            isDefaultOpen
          />
        )}
      </div>

      <ModalFooter
        primaryButtonText={t('common:startImportButton')}
        onPrimaryClick={onContinue}
        onSecondaryClick={onBack}
        secondaryButtonText={t('common:backButton')}
      />
    </div>
  );
};
